module.exports = fox._r("images/custom-select-arrow.png", __webpack_public_path__ + "_/_/_/common/frame/images/custom-select-arrow.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/custom-select-arrow.png
// module id = 106
// module chunks = 2